import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavParams, ToastController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { GoalsService } from 'src/app/goals/goals.service';

@Component({
    selector: 'app-select-number',
    templateUrl: './select-number.component.html',
    styleUrls: ['./select-number.component.scss'],
})
export class SelectNumberComponent implements OnInit {
    @Input() title: string = "";
    @Input() options: number[] = [];
    @Input() selectedNumber: number = null;

    constructor(
            protected _toastController: ToastController,
            protected _translationService: TranslationService,
            private _modalController: ModalController) {
    }

    ngOnInit() {
    }

    public save() {
        this.dismiss(this.selectedNumber);
    }
    
    public cancel() {
        this.dismiss();
    }

    public dismiss(data: any = null) {
        this._modalController.dismiss(data);
    }
}
